import React from 'react'
import { pick } from 'lodash-es'
import { useTbViewStore } from '@vt/hooks'
import { ButtonGroup } from '@ow/comps'

const ChangeView = function () {
  const { viewType, setViewType } = useTbViewStore((state) =>
    pick(state, ['viewType', 'setViewType'])
  )

  return (
    <ButtonGroup
      activeKey={viewType}
      options={[
        { key: 'calendar', label: '日历' },
        { key: 'list', label: '列表' },
      ]}
      onClick={() => {
        if (viewType === 'calendar') {
          setViewType('list')
        } else {
          setViewType('calendar')
        }
      }}
      borderRadius={4}
      backgroundColor="#fff"
      borderColor="#94A4B8"
      textColor="#94A4B8"
      activeBackgroundColor="rgb(var(--ow-primary-color))"
      activeBorderColor="rgb(var(--ow-primary-color))"
      activeTextColor="#fff"
    />
  )
}

export default ChangeView
